module.exports = __webpack_public_path__ + "static/media/receptionimg.27bcc073.png";